import React from "react";
import { Box, Typography } from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorIcon from "@material-ui/icons/Error";
import WarningIcon from "@material-ui/icons/Warning";
import clsx from "clsx";
import { RncValidationFeedback } from "../types";
import useAssistedAffiliationStyles from "../styles";

type RncValidationFeedbackCardProps = {
  feedback: RncValidationFeedback;
};

const RncValidationFeedbackCard = ({
  feedback,
}: RncValidationFeedbackCardProps) => {
  const classes = useAssistedAffiliationStyles();
  const isSuccess = feedback.tone === "success";
  const isError = feedback.tone === "error";
  const Icon = isSuccess ? CheckCircleOutlineIcon : isError ? ErrorIcon : WarningIcon;

  if (isSuccess) {
    return (
      <Box className={clsx(classes.rncFeedbackCard, classes.rncFeedbackSuccess)}>
        {feedback.lines?.map((line) => (
          <Box className={classes.rncFeedbackLine} key={line}>
            <Icon className={classes.rncFeedbackSuccessIcon} />
            <Typography variant="body2">{line}</Typography>
          </Box>
        ))}
      </Box>
    );
  }

  if (feedback.kind === "multipleIncidents") {
    return (
      <Box className={clsx(classes.rncFeedbackCard, classes.rncFeedbackError)}>
        <Typography className={classes.rncFeedbackTitle}>
          {feedback.title}
        </Typography>
        <Box className={classes.rncIncidentList}>
          {feedback.incidents?.map((incident) => (
            <Box className={classes.rncIncidentItem} key={incident}>
              <Icon className={classes.rncFeedbackErrorIcon} />
              <Typography variant="body2">{incident}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      className={clsx(
        classes.rncFeedbackCard,
        isError ? classes.rncFeedbackError : classes.rncFeedbackWarning
      )}
    >
      <Box className={classes.rncFeedbackMessage}>
        <Icon
          className={
            isError ? classes.rncFeedbackErrorIcon : classes.rncFeedbackWarningIcon
          }
        />
        <Box>
          {feedback.description ? (
            <Typography variant="body2">{feedback.description}</Typography>
          ) : null}

          {feedback.commercialName ? (
            <Box className={classes.rncFeedbackDetails}>
              <Typography variant="body2">
                <strong>Nombre Comercial:</strong>
              </Typography>
              <Typography variant="body2">
                <strong>{feedback.commercialName}</strong>
              </Typography>
            </Box>
          ) : null}

          {feedback.mid ? (
            <Typography className={classes.rncFeedbackDetails} variant="body2">
              MID: {feedback.mid}
            </Typography>
          ) : null}

          {feedback.foundStatus ? (
            <Box className={classes.rncFeedbackDetails}>
              <Typography variant="body2">Estado encontrado:</Typography>
              <Typography className={classes.rncFeedbackAdverseValue} variant="body2">
                {feedback.foundStatus}
              </Typography>
            </Box>
          ) : null}

          {feedback.registryNumber || feedback.status ? (
            <Box className={classes.rncFeedbackDetails}>
              {feedback.registryNumber ? (
                <Typography variant="body2">
                  <strong>Registro #:</strong> {feedback.registryNumber}
                </Typography>
              ) : null}
              {feedback.status ? (
                <Typography variant="body2">
                  <strong>Estado:</strong> {feedback.status}
                </Typography>
              ) : null}
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default RncValidationFeedbackCard;
